export default "__VITE_ASSET__gYM15L$J__"